export const baseColor = '#000000';
